
import { ref, computed, defineComponent } from "vue";
import { useStore } from 'vuex';
import qrcode from 'qrcode-generator';
import TokenService from "@/services/TokenService";
import ResponseData from "@/_models/ResponseData";
import { Helper } from "@/utils/Helper";
import OnboardingChecklistService from "@/services/OnboardingChecklistService";
import { useRouter } from "vue-router";
import tokensConfirmCreateTokenModal from "@/modules/tokens/components/modals/tokensConfirmCreateTokenModal.vue"
import { TransactionBuilderFactory, MosaicMetadataTransactionBuilder, AccountHttp, Address, MetadataQueryParams, MetadataType, MetadataHttp, Convert, MosaicId, PublicAccount, UInt64 } from "tsjs-xpx-chain-sdk";
import { Peer } from "peerjs";

export default defineComponent({
  name: 'tokensImportAssetFormComponent',
  props: {
    supply: Number,
    assetId: String,
    publicKey: String,
    network: String,
    divisibility: Number,
  },
  components: {
    tokensConfirmCreateTokenModal,
  },
  setup(props, {emit}){
    const store = useStore();
    const router = useRouter();

    const selectedTokenType = ref('IGT');
    const tokenName = ref('');
    const tokenSymbol = ref('');
    const oriSelectedTokenType = ref('');
    const oriTokenName = ref('');
    const oriTokenSymbol = ref('');
    const isDisplayUploadTokenImageLabel = ref(false);
    const imageFile = ref("");
    const fileName = ref("");
    const previewImage = ref("");
    const fileInput = ref(null);
    const qr = ref('');
    const isQRModalShow = ref(false);
    const userData = store.getters['auth/user'];
    const jwtToken = store.getters['auth/jwtToken'];
    const mainnetJwtToken = store.getters['auth/mainnetJwtToken'];
    const isXarcadeExist = ref(false);
    const disableSubmit = ref(false);

    const isDisabledModalConfirmSubmitButton = ref(false);
    const showUploadingLoader = ref(false);

    const isMultisig = ref(false);
    let accountHttp = new AccountHttp(props.network=='Testnet'?store.getters['config/getTestnetApi']:store.getters['config/getMainnetApi']);
    let metadataHttp = new MetadataHttp(props.network=='Testnet'?store.getters['config/getTestnetApi']:store.getters['config/getMainnetApi']);
    (async() => {
      // fetch metadata of the asset
      let xarcadeHex = Convert.utf8ToHex('xarcade');
      let xarcadeHexData = xarcadeHex + "00".repeat((16-xarcadeHex.length)/2)
      let metadataQueryParams = new MetadataQueryParams();
      metadataQueryParams.targetId = new MosaicId(props.assetId);
      metadataQueryParams.metadataType = MetadataType.MOSAIC;
      metadataQueryParams.scopedMetadataKey = UInt64.fromHex(xarcadeHexData);

      let searchResults = await metadataHttp.searchMetadata(metadataQueryParams).toPromise();
      let assetMetadata:any;
      if(searchResults.metadataEntries.length){
        assetMetadata = JSON.parse(searchResults.metadataEntries[0].value);
      }
      // display metadata
      tokenName.value = assetMetadata.name;
      oriTokenName.value = assetMetadata.name;
      tokenSymbol.value = assetMetadata.symbol;
      oriTokenSymbol.value = assetMetadata.symbol;
      selectedTokenType.value = assetMetadata.type;
      oriSelectedTokenType.value = assetMetadata.type;

      // if(selectedTokenType.value == 'IGT'){
      //   selectedTokenTypeLabel.value = 'In-Game Token';
      // }else if(selectedTokenType.value == 'LET'){
      //   selectedTokenTypeLabel.value = 'Limited Edition Token';
      // }else if(selectedTokenType.value == 'NFT'){
      //   selectedTokenTypeLabel.value = 'Non-Fungible Token';
      // }
      // disableCreate.value = tokenName.value.trim() == '' || tokenSymbol.value.trim() == '' || selectedTokenType.value == '';

      let multisigInfo = await accountHttp.getMultisigAccountInfo(Address.createFromRawAddress(props.network=='Testnet'?userData.testnetWalletAddress:userData.mainnetWalletAddress)).toPromise()
      isMultisig.value = multisigInfo.cosignatories.length > 0 ? true : false;
    })();

    const disableCreate = computed(() => {
      if(disableSubmit.value){
        return true;
      }else{
        if(selectedTokenType.value=='NFT'){
          return tokenName.value.trim() == '' || tokenSymbol.value.trim()=='' || props.supply != 1;
        }else{
          return tokenName.value.trim() == '' || tokenSymbol.value.trim()=='';
        }
      }
    });

    const pickFile = () => {
      let input = fileInput.value;
      let file = input.files;
      fileName.value = file[0].name;
      imageFile.value = file;

      if (file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          previewImage.value = e.target.result.toString();
        };
        reader.readAsDataURL(file[0]);
        emit("input", file[0]);
        // isDisplaySaveTokenImageOptions.value = true;
      }
    };

    const revertTokenImage = () => {
      isDisplayUploadTokenImageLabel.value = false;
      fileInput.value = null;
      previewImage.value = '';
    };

    const updateTokenImage = () => {
      isDisplayUploadTokenImageLabel.value = false;
    };

    const importToken = async() => {
      if(oriTokenName.value == tokenName.value.trim() && oriTokenSymbol.value == tokenSymbol.value.trim() && oriSelectedTokenType.value == selectedTokenType.value){
        isXarcadeExist.value = true;
        linkToken();
      }else{
        isXarcadeExist.value = true;
        await linkTokenQR();
      }
    }

    const linkTokenQR = async () => {
      if (userData !== "" && jwtToken !== "") {
        const publicAcc = PublicAccount.createFromPublicKey(props.publicKey, props.network=='Testnet'?store.getters['config/getTestnetNetworkType']:store.getters['config/getMainnetNetworkType']);
        let transactionBuilderFactory = new TransactionBuilderFactory();
        transactionBuilderFactory.networkType = props.network=='Testnet'?store.getters['config/getTestnetNetworkType']:store.getters['config/getMainnetNetworkType'];

        let xarcadeHex = Convert.utf8ToHex('xarcade');
        let xarcadeHexData = xarcadeHex + "00".repeat((16-xarcadeHex.length)/2)

        let xarcadeValue = {
          name: tokenName.value,
          symbol: tokenSymbol.value,
          type: selectedTokenType.value
        }

        let oldValue = '';

        let metadataQueryParams = new MetadataQueryParams();
        metadataQueryParams.targetId = new MosaicId(props.assetId);
        metadataQueryParams.metadataType = MetadataType.MOSAIC;
        metadataQueryParams.scopedMetadataKey = UInt64.fromHex(xarcadeHexData);

        let searchResults = await metadataHttp.searchMetadata(metadataQueryParams).toPromise();
        if(searchResults.metadataEntries.length){
          oldValue = searchResults.metadataEntries[0].value;
        }

        let txnBuilder: MosaicMetadataTransactionBuilder = transactionBuilderFactory.mosaicMetadata();
        let mosaicMetadataTransaction = txnBuilder
          .targetPublicKey(publicAcc)
          .targetMosaicId(new MosaicId(props.assetId))
          .scopedMetadataKey(UInt64.fromHex(xarcadeHexData))
          .value(JSON.stringify(xarcadeValue) )
          .oldValue(oldValue)
          .calculateDifferences()
          .build()

        let aggregateTx = isMultisig.value?
        transactionBuilderFactory.aggregateBonded().innerTransactions([mosaicMetadataTransaction.toAggregate(publicAcc)]).build():
        transactionBuilderFactory.aggregateComplete().innerTransactions([mosaicMetadataTransaction.toAggregate(publicAcc)]).build()

        const peer = new Peer();
        peer.on("open", (id) => {
          // create QR
          const qrCode = qrcode(0, 'H');
          let data = {
            payload:aggregateTx.serialize(),
            type:'sign',
            recvId: peer.id,
            generationHash: props.network=='Testnet'?store.getters['config/getTestnetGenerationHash']:store.getters['config/getMainnetGenerationHash'],
            callbackUrl: null
          }
          qrCode.addData(JSON.stringify(data));
          qrCode.make();
          qr.value = qrCode.createSvgTag({scalable: true});
        });

        peer.on("connection", (conn) => {
          // console.log("connected to " + conn.peer);
          conn.on("data", (data: any) => {
            conn.send("success");
          });
        });
        isQRModalShow.value = true;
      }
    }

    const linkToken = () => {
      isDisabledModalConfirmSubmitButton.value = true;
      showUploadingLoader.value = true;
      disableSubmit.value = true;

      let data = new FormData();
      data.append("userId", userData.userId);
      data.append("assetId", props.assetId);

      if (tokenName.value !== "") {
        data.append("title", tokenName.value);
        data.append("symbol", tokenSymbol.value);
        data.append("type", selectedTokenType.value);

        if (imageFile.value !== "") {
          data.append("logoStream", imageFile.value[0]);
        }

        TokenService.createToken(data, props.network=='Testnet'?jwtToken:mainnetJwtToken, props.network=='Testnet'?'testnet':'mainnet')
          .then((response: ResponseData) => {
            isQRModalShow.value = false;
            showUploadingLoader.value = false;
            isDisabledModalConfirmSubmitButton.value = false;
            disableSubmit.value = false;
            Helper.toastSuccessHandling(response.data['message']);
            updateOnboardingChecklist(userData.userId, jwtToken);
            router.push({ name: 'viewTokensList' });
          })
          .catch((error) => {
            isDisabledModalConfirmSubmitButton.value = false;
            showUploadingLoader.value = false;
            disableSubmit.value = false;
            Helper.endpointErrorHandling(error);
          });
      } else {
        isDisabledModalConfirmSubmitButton.value = false;
        showUploadingLoader.value = false;
        Helper.endpointErrorHandling('', 'Token name is empty!');
      }
    }

    const updateOnboardingChecklist = (userId: string, jwtToken: string) => {
      OnboardingChecklistService.getOnboardingChecklist(userId, jwtToken)
        .then((response: ResponseData) => {
          OnboardingChecklistService.saveUpdatedOnboardingChecklist(response.data.items, props.network=='Testnet'?6:10, userId, jwtToken);
        })
        .catch((error) => {
          Helper.endpointErrorHandling(error);
        });
    }

    return{
      imageFile,
      fileName,
      previewImage,
      tokenName,
      tokenSymbol,
      selectedTokenType,
      pickFile,
      revertTokenImage,
      updateTokenImage,
      disableCreate,
      isDisplayUploadTokenImageLabel,
      fileInput,
      linkTokenQR,
      isQRModalShow,
      qr,
      isDisabledModalConfirmSubmitButton,
      showUploadingLoader,
      linkToken,
      isXarcadeExist,
      importToken,
    }
  },

  emits:[
    'closeForm', 'input'
  ],
});
